import { h, Component, Host, State, Prop, Method } from '@stencil/core';
import { environment } from '../../utils/environment.js';
import searchIcon from './search-icon';

window.PS = window.PS || {};

type Market = {
  marketId: string;
  marketType: string;
  name: string;
  url: string;
};

@Component({
  shadow: true,
  styleUrl: 'igws-market-search.less',
  tag: 'igws-market-search',
})
export class MarketSearch {
  @State() searchResults: Market[] = [];

  @Prop() country: string = window.PS.util?.jspVars.jspVarsValues.websiteCountry;

  @Prop() resultsLimit = 4;

  @Prop() placeholder = '';

  searchTerm!: string;

  handleInput(event: InputEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;
    this.getSearchResults();
  }

  getSearchResults() {
    const endpoint = '/ig-proxy/marketsearch/suggest?cq_locale=';
    const locale =
      document.querySelector('meta[name="locale"]')?.getAttribute('content') ||
      document.documentElement.lang.replace('-', '_');
    const requestUrl = `https://${environment()}.ig.com/${this.country}${endpoint}${locale}&query=${this.searchTerm}`;
    window.PSC.fetchCall({ requestUrl }, this.handleResponse.bind(this));
  }

  handleResponse(response: { type: string; body: { searchResults: Market[] } }) {
    switch (response.type) {
      case 'success':
        this.setResults(response.body.searchResults);
        break;
      case 'failure':
        console.error('Market Search service failed: ', response.body);
        break;
      default:
        console.error('Error running fetchCall');
    }
  }

  @Method()
  async setResults(results: any[]) {
    this.searchResults = this.limitResults(results, this.resultsLimit);
  }

  limitResults(results: Market[], limit: number) {
    return results.filter((_result, index: number) => index < limit);
  }

  highlightResult(str: string, value: string) {
    const idx = str.toLowerCase().indexOf(value.toLowerCase());
    const before = str.substring(0, idx);
    const highlight = str.substring(idx, idx + value.length);
    const after = str.substring(idx + value.length);
    return (
      <span>
        {before}
        <mark>{highlight}</mark>
        {after}
      </span>
    );
  }

  render() {
    const { country, placeholder, searchTerm, searchResults } = this;
    return (
      <Host>
        <form action={`https://${environment()}.ig.com/${country}/ig-search`} role="search">
          <input
            type="search"
            onInput={this.handleInput.bind(this)}
            autocomplete="off"
            placeholder={placeholder}
            required
          />
          <input type="hidden" name="query" value={searchTerm} />
          <button type="submit">{searchIcon}</button>
        </form>
        {searchResults.length ? (
          <ul class="search-results">
            {searchResults.map((market: Market) => (
              <li>
                <a href={`https://${environment()}.ig.com/${country}${market.url}`}>
                  {this.highlightResult(market.name, searchTerm)}
                </a>
              </li>
            ))}
          </ul>
        ) : null}
      </Host>
    );
  }
}
